module.exports = __webpack_public_path__ + "static/media/facebook.57645219.png";